import { useNavigate, useParams } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import type { InstallmentPlanTemplateDTO } from "../../domain/contracts";
import {
  useOutsourceApInstallmentPlanTemplateQuery,
  useUpdateOutsourceApInstallmentPlanTemplate,
} from "../api/queries";
import { InstallmentPlanTemplateForm } from "../ui/InstallmentPlanTemplateForm";

export function OutsourceApInstallmentPlanTemplateEditPage() {
  const { id } = useParams({
    from: "/app/performance/settings/outsource-ap-installment-plans/$id/edit",
  });
  const nav = useNavigate({
    from: "/app/performance/settings/outsource-ap-installment-plans/$id/edit",
  });
  const { data, isLoading } = useOutsourceApInstallmentPlanTemplateQuery(id);
  const updateTemplate = useUpdateOutsourceApInstallmentPlanTemplate(id);

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            {
              label: "ແມ່ແບບງວດ AP",
              to: "/app/performance/settings/outsource-ap-installment-plans",
            },
            { label: "ແກ້ໄຂ" },
          ]}
        />
      </Header>

      <Main>
        {isLoading || !data ? (
          <p className="text-muted-foreground">ກຳລັງໂຫຼດ...</p>
        ) : (
          <div className="rounded-xl border bg-card px-6">
            <InstallmentPlanTemplateForm
              initialValues={data as InstallmentPlanTemplateDTO}
              onSubmit={async (vals) => {
                await updateTemplate.mutateAsync(vals);
                nav({
                  to: "/app/performance/settings/outsource-ap-installment-plans",
                });
              }}
              submitting={updateTemplate.isPending}
            />
          </div>
        )}
      </Main>
    </>
  );
}
